import Model from "../../core/model/Model";
import { TSearchResultSummary } from "./SearchResultSummary";

export type TFacet = {
  [property: string]: number;
};

export type TFacetCollection = {
  [key: string]: TFacet;
};

export type THighlightCollection = {
  [documentId: string]: {
    [property: string]: string[];
  };
};

export type TSearchResult = {
  collection: string;
  id: string;
  collection_item_id: number;
  status: string;
  summary: string;
  [key: string]: any;
  organisation_id: number;
  organisation_name: string;
  index_id_is: number[];
  index_type_id_is: number[];
  attr_index_name: string[];
  attr_parent_index_name: string[];
  primary_court_case_number_s: string;
  valid: boolean;
  _version_: number;
  date_dt: Date;
  decision_date_dt: Date;
};
export interface TSearchResponse {
  facets: TFacetCollection;
  results: TSearchResult[];
  highlights: THighlightCollection;
  summary: TSearchResultSummary;
}

export interface ISearchResponse extends TSearchResponse {
  formattedResults: TSearchResult[];
}

const SearchResponse = Model((model: TSearchResponse): ISearchResponse => {
  const _value: TSearchResponse = Object.assign({}, model);

  let _model = {
    get facets() {
      return _value.facets;
    },
    set facets(value) {
      _value.facets = value;
    },
    get results() {
      return _value.results;
    },
    set results(value) {
      _value.results = value;
    },
    get highlights() {
      return _value.highlights;
    },
    set highlights(value) {
      _value.highlights = value;
    },
    get summary() {
      return _value.summary;
    },
    set summary(value) {
      _value.summary = value;
    },
    get formattedResults() {
      return (_value.results || []).map((item) => {
        var highlightedSummary = _value.highlights[item.id]?.summary?.[0];
        if (highlightedSummary) {
          item.summary = highlightedSummary;
        }
        return item;
      });
    }
  };
  return _model;
});

export default SearchResponse;
